import StringInput from './StringInput';
import React, {} from 'react';

function TextInput(props) {

    return (
        <StringInput
            data={props.data}
            handleChange={props.handleChange}
            formData={props.formData}
        />
    );
}

export default TextInput;